import { render, staticRenderFns } from "./SettingsFov.vue?vue&type=template&id=39de121a&scoped=true&"
import script from "./SettingsFov.vue?vue&type=script&lang=js&"
export * from "./SettingsFov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de121a",
  null
  
)

export default component.exports